// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 636) return "js/636.js";
	if (chunkId === 698) return "js/698.js";
	// return url for filenames based on template
	return undefined;
};